import React,{useEffect} from 'react';


import economic2 from '../../images/economic room/economic2.jpg';
import { Button, Carousel, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';
import {IoIosArrowBack} from 'react-icons/io';

import economic1 from '../../images/economic room converted/economic1.jpg';
import economic22 from '../../images/economic room converted/economic2.jpg';
import economic3 from '../../images/economic room converted/economic3.jpg';
import EcoVid from '../../videos/EconomyVideo01.mp4';
import { HashLink as Link } from 'react-router-hash-link';
import Aos from "aos";
import "aos/dist/aos.css";

import './PremiumRoom.css';

function PremiumRoomPage() {

    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <div>
            <section  className='HeaderPageWrapper'>
                {/* <img src={economic2} alt='tof' className='luxRoom' /> */}
                <a href='https://www.youtube.com/watch?v=zGbXyNo2z54'>
                    <video className='videoTag' autoPlay loop muted >
                        <source src={EcoVid} type='video/mp4' />
                    </video>
                </a>
                <div className='headerWrapperPrem'>
                    <h1>ECONOMIC DOUBLE ROOMS</h1>
                </div> 
            </section>
        <section className='DiscoverBody'>  
            <section id='lux' className='MovingCard1'>
            <div className='PrevBox'>
                <Link to='/discover/#economic' className='Previous' ><IoIosArrowBack />  Rooms /</Link>
                <Link className='present' to='/luxroom'>Economic Double</Link>
            </div>
            <div className='room-list-wrapper'>
              
                  <Container data-Aos='fade-in'  className='image-wrapper'>
                        {/* <video className='imageTag' controls  muted >
                            <source src={Video} type='video/mp4' />
                        </video> */}
                        <Carousel interval={null} fade='true'  >
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                              src = {economic22}
                              alt = "" />
                          
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {economic3}
                            alt = "" />
                            
                          </Carousel.Item>
                          <Carousel.Item className='CarouselWrapper' >
                            <img className = "CarouselPhoto"
                            src = {economic1}
                            alt = "" />
                          
                          </Carousel.Item>
                          
                    </Carousel> 
                      
                  </Container>
              
              
                  <div data-Aos='fade-in' className='features-wrapper1'>
                      <div className='content-header'>
                        <h3 className='executive-header'>ECONOMIC DOUBLE </h3>
                       
                      </div>
                      
                      <div>
                          <p>
                          The Economy Double Room in our Hotel welcomes you in a cosy ambience 
                          for a carefree resting experience. Here, single or two travellers enjoy 
                          all the comfort they need for a relaxing stay at an unmatchable price with the 
                          following facilities:
                          </p>
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between'}}>
                          <ul>
                            <li>Air Conditioning</li>
                            <li>Queen Size Bed</li>
                            <li>Premium Linen & Bedding</li>
                            <li>LED TV with Tata Sky</li>
                            <li>Direct Dial Telephone</li>
                            <li>Bathroom with Shower</li>
                            <li>Razor Plug</li>
                            <li>Laundry Services (Fees are applied)</li>
                            <li>24 Hrs Room Service</li>
                            

                          </ul>
                          <ul>
                            <li>Wake-Up Call</li>
                            <li>Wi-Fi Internet Access Free of Charge</li>
                            <li>Bath Amenities – Herbal Soap & Shampoo</li>
                            <li>24 Hrs Hot Water</li>
                            <li>Closet with Lock</li>
                            <li>Daily Housekeeping</li>
                            <li>Modern Furnishing</li>
                            <li>Deep Room Sanitization</li>
                            <li>Modern Furnishing</li>
                            
                          </ul>
                          </div>
                      <div className='bookNowClassic'>
                      <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                            <Button className='bookNowlink'style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                          </a>
                      </div>
                  </div>
              
              

            </div>
          
        </section>
        </section>
        </div>
    )
}

export default PremiumRoomPage
